<template>
  <v-container fluid>
    <v-overlay style="z-index: 9999" :value="mostrarTabla">
      <v-progress-circular persistent indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div></div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="875"
      v-model="dialogCarrouselFotos"
    >
      <template>
        <v-card>
          <v-toolbar color="primary" dark>Fotos</v-toolbar>
          <v-card-text>
            <v-carousel>
              <v-carousel-item
                v-for="(item, i) in fotos_carrousel"
                :key="i"
                :src="item"
                reverse-transition="fade-transition"
                transition="fade-transition"
              ></v-carousel-item>
            </v-carousel>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="dialogCarrouselFotos = false">Salir</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="375"
      v-model="dialog_info_equipo"
    >
      <template>
        <v-card max-width="375" class="mx-auto">
          <v-img v-if="info_equipo.fotos" :src="info_equipo.fotos[2]" height="300px" dark>
            <v-row class="fill-height">
              <v-card-title>
                <v-spacer></v-spacer>
                <v-btn dark class="mr-4" icon @click="dialog_info_equipo = false">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </v-card-title>
              <v-spacer></v-spacer>
              <v-card-title class="white--text pl-12 pt-12"> </v-card-title>
            </v-row>
          </v-img>

          <v-list two-line>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary"> mdi-apps </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  ><span style="font-size: 12px">Tipo de Unidad</span></v-list-item-title
                >
                <v-list-item-subtitle>{{ info_equipo.tipoUnidad }}</v-list-item-subtitle>

                <v-list-item-title
                  ><span style="font-size: 12px">Año</span></v-list-item-title
                >
                <v-list-item-subtitle>{{ info_equipo.anio }}</v-list-item-subtitle>
                <v-list-item-title
                  ><span style="font-size: 12px">Capacidad</span></v-list-item-title
                >
                <v-list-item-subtitle>{{ info_equipo.capacidad }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary"> mdi-barcode </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title
                  ><span style="font-size: 12px">Numero de Serie</span></v-list-item-title
                >
                <v-list-item-subtitle>{{ info_equipo.numeroSerie }}</v-list-item-subtitle>
                <v-list-item-title
                  ><span style="font-size: 12px">Numero de Placa</span></v-list-item-title
                >
                <v-list-item-subtitle>{{ info_equipo.placa }}</v-list-item-subtitle>
                <v-list-item-title
                  ><span style="font-size: 12px"
                    >Fecha de Adquisición</span
                  ></v-list-item-title
                >
                <v-list-item-subtitle>{{
                  info_equipo.fechaDeAdquisicion
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary"> mdi-cash </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title
                  ><span style="font-size: 12px">Factura</span></v-list-item-title
                >
                <v-list-item-subtitle>{{ info_equipo.factura }}</v-list-item-subtitle>
                <v-list-item-title
                  ><span style="font-size: 12px"
                    >Numero Economico</span
                  ></v-list-item-title
                >
                <v-list-item-subtitle>{{
                  info_equipo.numeroEconomico
                }}</v-list-item-subtitle>
                <v-list-item-title
                  ><span style="font-size: 12px"
                    >Costo de la Unidad</span
                  ></v-list-item-title
                >
                <v-list-item-subtitle
                  >${{ this.costoToDollar(info_equipo.costo) }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary"> mdi-badge-account </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title
                  ><span style="font-size: 12px">Resguardo</span></v-list-item-title
                >
                <v-list-item-subtitle v-if="info_equipo.personal">{{
                  info_equipo.personal.nombreCompleto
                }}</v-list-item-subtitle>
                <v-list-item-title
                  ><span style="font-size: 12px">Propietario</span></v-list-item-title
                >
                <v-list-item-subtitle v-if="info_equipo.personal">{{
                  info_equipo.personal.empresa.razonSocial
                }}</v-list-item-subtitle>
                <v-list-item-title
                  ><span style="font-size: 12px">Ubicación</span></v-list-item-title
                >
                <v-list-item-subtitle v-if="info_equipo.personal">{{
                  info_equipo.ubicacion.ubicacion
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="375"
      v-model="dialog_info_equipo"
    >
      <template>
        <v-card max-width="375" class="mx-auto">
          <v-img v-if="info_equipo.fotos" :src="info_equipo.fotos[2]" height="300px" dark>
            <v-row class="fill-height">
              <v-card-title>
                <v-spacer></v-spacer>
                <v-btn dark class="mr-4" icon @click="dialog_info_equipo = false">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </v-card-title>

              <v-spacer></v-spacer>

              <v-card-title class="white--text pl-12 pt-12"> </v-card-title>
            </v-row>
          </v-img>

          <v-list two-line>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary"> mdi-apps </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  ><span style="font-size: 12px">Tipo de Unidad</span></v-list-item-title
                >
                <v-list-item-subtitle>{{ info_equipo.tipoUnidad }}</v-list-item-subtitle>

                <v-list-item-title
                  ><span style="font-size: 12px">Año</span></v-list-item-title
                >
                <v-list-item-subtitle>{{ info_equipo.anio }}</v-list-item-subtitle>
                <v-list-item-title
                  ><span style="font-size: 12px">Capacidad</span></v-list-item-title
                >
                <v-list-item-subtitle>{{ info_equipo.capacidad }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary"> mdi-barcode </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title
                  ><span style="font-size: 12px">Numero de Serie</span></v-list-item-title
                >
                <v-list-item-subtitle>{{ info_equipo.numeroSerie }}</v-list-item-subtitle>
                <v-list-item-title
                  ><span style="font-size: 12px">Numero de Placa</span></v-list-item-title
                >
                <v-list-item-subtitle>{{ info_equipo.placa }}</v-list-item-subtitle>
                <v-list-item-title
                  ><span style="font-size: 12px"
                    >Fecha de Adquisición</span
                  ></v-list-item-title
                >
                <v-list-item-subtitle>{{
                  info_equipo.fechaDeAdquisicion
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary"> mdi-cash </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title
                  ><span style="font-size: 12px">Factura</span></v-list-item-title
                >
                <v-list-item-subtitle>{{ info_equipo.factura }}</v-list-item-subtitle>
                <v-list-item-title
                  ><span style="font-size: 12px"
                    >Numero Economico</span
                  ></v-list-item-title
                >
                <v-list-item-subtitle>{{
                  info_equipo.numeroEconomico
                }}</v-list-item-subtitle>
                <v-list-item-title
                  ><span style="font-size: 12px"
                    >Costo de la Unidad</span
                  ></v-list-item-title
                >
                <v-list-item-subtitle
                  >${{ this.costoToDollar(info_equipo.costo) }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary"> mdi-badge-account </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title
                  ><span style="font-size: 12px">Resguardo</span></v-list-item-title
                >
                <v-list-item-subtitle v-if="info_equipo.personal">{{
                  info_equipo.personal.nombreCompleto
                }}</v-list-item-subtitle>
                <v-list-item-title
                  ><span style="font-size: 12px">Propietario</span></v-list-item-title
                >
                <v-list-item-subtitle v-if="info_equipo.personal">{{
                  info_equipo.personal.empresa.razonSocial
                }}</v-list-item-subtitle>
                <v-list-item-title
                  ><span style="font-size: 12px">Ubicación</span></v-list-item-title
                >
                <v-list-item-subtitle v-if="info_equipo.personal">{{
                  info_equipo.ubicacion.ubicacion
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="875"
      v-model="dialogAgregarAvatar"
    >
      <template>
        <v-card>
          <v-toolbar color="primary" dark>Agregar Avatar</v-toolbar>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" sm="12" lg="12" md="12">
                <v-file-input
                  v-model="avatar_unidad"
                  accept="image/*"
                  label="Imagen"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="dialogAgregarAvatar = false">Salir</v-btn>
            <v-btn text @click="subirAvatarUnidad">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <div class="tables-basic pa-3">
      <br />
      <h2 v-if="verNuevo == 0" class="texto mt-16 mb-6">Activos Fijos</h2>
      <span class="texto" style="font-size: 12px"
        >En este modulo, están listados los activos fijos del corporativo, incluyendo
        grúas terrestres, montacargas y tractocamiones.</span
      >
      <div class="input-filter mb-5 mt-5">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" color="primary" class="mb-2">
              <v-icon>mdi-filter-plus</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item dense @click="showFilterNumeroEconomico = true">
              <v-list-item-title>
                <span class="texto">Numero Economico</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item dense @click="showFilterTipoUnidad = true">
              <v-list-item-title>
                <span class="texto">Tipo de Unidad</span></v-list-item-title
              >
            </v-list-item>
            <v-list-item dense @click="showFilterNumeroSerie = true">
              <v-list-item-title>
                <span class="texto">Numero de Serie</span></v-list-item-title
              >
            </v-list-item>
            <v-list-item dense @click="showFilterPlaca = true">
              <v-list-item-title>
                <span class="texto">Numero de Placa</span></v-list-item-title
              >
            </v-list-item>
            <v-list-item dense @click="showFilterestatus = true">
              <v-list-item-title> <span class="texto">Estatus</span></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <div v-if="arr.length == 0" class="filter-label">
          <span>Ningun filtro seleccionado...</span>
        </div>
        <div v-else class="filter-chips">
          <v-chip
            class="ml-2"
            v-for="(item, index) in arr"
            :key="index"
            close
            close-icon="mdi-close-circle"
            @click:close="eliminarFiltro(index)"
            color="primary"
            small
          >
            {{ item.label }}
          </v-chip>
        </div>

        <v-dialog
          v-model="showFilterNumeroEconomico"
          transition="dialog-bottom-transition"
          max-width="350"
        >
          <v-card>
            <v-toolbar color="primary" dark>Busqueda por Numero Economico</v-toolbar>
            <v-card-text class="mt-10">
              <v-text-field
                v-model="numero_economico_filter"
                outlined
                dense
                label="Ingrese el numero economico a filtrar"
              ></v-text-field>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="filtroLabelPush('numeroEconomico')">Aplicar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="showFilterTipoUnidad"
          transition="dialog-bottom-transition"
          max-width="350"
        >
          <v-card>
            <v-toolbar color="primary" dark>Busqueda por Tipo de Unidad</v-toolbar>
            <v-card-text class="mt-10">
              <v-select
                v-model="tipo_unidad_filter"
                :items="[
                  'Autos y Pick Ups',
                  'Motocicletas',
                  'Tractocamion',
                  'Plataforma',
                  'Grúa Terrestre',
                  'Montacargas',
                  'Cargador Frontal',
                ]"
                outlined
                dense
                label="Ingrese el tipo de unidad"
              ></v-select>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="filtroLabelPush('tipoUnidad')">Aplicar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="showFilterNumeroSerie"
          transition="dialog-bottom-transition"
          max-width="350"
        >
          <v-card>
            <v-toolbar color="primary" dark>Busqueda Numero de Serie</v-toolbar>
            <v-card-text class="mt-10">
              <v-text-field
                v-model="numero_serie_filter"
                outlined
                dense
                label="Ingrese el numero de serue"
              ></v-text-field>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="filtroLabelPush('numeroSerie')">Aplicar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="showFilterPlaca"
          transition="dialog-bottom-transition"
          max-width="350"
        >
          <v-card>
            <v-toolbar color="primary" dark>Busqueda por Placa</v-toolbar>
            <v-card-text class="mt-10">
              <v-text-field
                v-model="numero_placa_filter"
                outlined
                dense
                label="Ingrese el numero de placa"
              ></v-text-field>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="filtroLabelPush('placa')">Aplicar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="showFilterestatus"
          transition="dialog-bottom-transition"
          max-width="350"
        >
          <v-card>
            <v-toolbar color="primary" dark>Busqueda por Estatus</v-toolbar>
            <v-card-text class="mt-10">
              <v-select
                v-model="estatus_filter"
                :items="['Operativo', 'Fuera de Servicio']"
                outlined
                dense
                label="Ingrese el estatus"
              ></v-select>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="filtroLabelPush('estatus')">Aplicar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <v-row>
        <v-col cols="12">
          <v-data-table
            style="border-radius: 10px"
            dense
            :headers="headers"
            :items="activos"
            :items-per-page="40"
            item-key="nombreComercial"
            v-if="verNuevo == 0"
            :loading="mostrarTabla"
            hide-default-footer
            class="elevation-3"
          >
            <template v-slot:[`header.nombreActivo`]="{ header }">
              <span class="texto" style="font-size: 14px; color: rgb(231, 231, 231)"
                >{{ header.text.toUpperCase() }}
              </span>
            </template>
            <template v-slot:[`header.estatu`]="{ header }">
              <span class="texto" style="font-size: 14px; color: rgb(231, 231, 231)"
                >{{ header.text.toUpperCase() }}
              </span>
            </template>
            <template v-slot:[`header.marca`]="{ header }">
              <span class="texto" style="font-size: 14px; color: rgb(231, 231, 231)"
                >{{ header.text.toUpperCase() }}
              </span>
            </template>
            <template v-slot:[`header.numeroSerie`]="{ header }">
              <span class="texto" style="font-size: 14px; color: rgb(231, 231, 231)"
                >{{ header.text.toUpperCase() }}
              </span>
            </template>
            <template v-slot:[`header.modelo`]="{ header }">
              <span class="texto" style="font-size: 14px; color: rgb(231, 231, 231)"
                >{{ header.text.toUpperCase() }}
              </span>
            </template>
            <template v-slot:[`header.fotosAdjuntos`]="{ header }">
              <span class="texto" style="font-size: 14px; color: rgb(231, 231, 231)"
                >{{ header.text.toUpperCase() }}
              </span>
            </template>
            <template v-slot:[`header.opciones`]="{ header }">
              <span
                class="texto"
                style="text-align: center; font-size: 14px; color: rgb(231, 231, 231)"
                >{{ header.text.toUpperCase() }}
              </span>
            </template>

            <template v-slot:[`item.nombreActivo`]="{ item }">
              <div>
                <v-avatar v-if="item.avatar" color="grey" size="40" tile class="ma-1">
                  <img :src="item.avatar" />
                </v-avatar>
                <span
                  class="texto"
                  style="
                    color: #202020;
                    font-size: 11px;
                    font-weight: bold;
                    text-transform: uppercase;
                  "
                  >{{
                    `${item.tipoUnidad}
                                    ${item.numeroEconomico}`
                  }}</span
                >
              </div>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-icon @click="generarPdf(item)" small class="mr-2">mdi-download</v-icon>
              <v-icon @click="editItem(item)" small class="mr-2">mdi-border-color</v-icon>
            </template>
            <template v-slot:[`item.estatu`]="{ item }">
              <v-chip
                label
                outlined
                class="texto"
                small
                v-if="item.estatu == 'N/D'"
                color="gray"
              >
                N/D
              </v-chip>
              <v-chip
                label
                outlined
                class="texto"
                small
                v-if="item.estatu == 'Operativo'"
                color="green"
              >
                Operativo
              </v-chip>
              <v-chip
                label
                outlined
                class="texto"
                small
                v-if="item.estatu == 'Fuera de Servicio'"
                color="orange"
              >
                Fuera de Servicio
              </v-chip>
              <v-chip
                class="texto"
                label
                outlined
                small
                v-if="item.estatu == 'No Localizado'"
                color="black"
              >
                No Localizado
              </v-chip>
              <v-badge
                v-if="item.estatu == 'Baja'"
                :value="hover"
                color="deep-purple accent-6"
                v-bind:content="item.observaciones"
                left
                transition="slide-x-transition"
              >
                <v-hover v-model="hover">
                  <v-chip
                    small
                    v-if="item.estatu == 'Baja'"
                    color="red"
                    text-color="white"
                  >
                    Baja
                  </v-chip>
                </v-hover>
              </v-badge>
            </template>

            <template v-slot:[`item.fotosAdjuntos`]="{ item }">
              <div class="">
                <v-btn
                  v-if="item.fotos.length > 0"
                  icon
                  color="green"
                  @click="mostrarCarrousel(item.fotos)"
                >
                  <v-icon> mdi-camera-plus</v-icon>
                </v-btn>

                <v-menu
                  v-if="item.documentacionInfo.length > 0"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="mr-2" v-bind="attrs" v-on="on">
                      mdi-file-document
                    </v-icon>
                  </template>

                  <v-card>
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>Adjuntos</v-list-item-title>
                          <v-list-item-subtitle>Documentos</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>

                    <v-divider></v-divider>

                    <v-list
                      v-for="(documentos, index) in item.documentacionInfo"
                      :key="index"
                    >
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon
                            class="mr-2"
                            @click="descargarDocumentos(documentos.documentacion)"
                          >
                            mdi-link-variant
                          </v-icon>
                        </v-list-item-action>

                        <v-list-item-subtitle>{{
                          documentos.nombreDocumento
                        }}</v-list-item-subtitle>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </div>
            </template>
            <template v-slot:[`item.marca`]="{ item }">
              <span class="texto" style="color: gray; font-size: 12px">
                {{ item.marca }}
              </span>
            </template>
            <template v-slot:[`item.modelo`]="{ item }">
              <span
                v-if="item.empresa"
                class="texto"
                style="color: gray; font-size: 12px"
              >
                {{ item.empresa.nombreComercial }}
              </span>
            </template>
            <template v-slot:[`item.numeroSerie`]="{ item }">
              <span style="color: gray; font-size: 12px; font-style: italic">{{
                item.numeroSerie
              }}</span>
            </template>
            <template v-slot:[`item.opciones`]="{ item }">
              <v-menu :close-on-content-click="false" :nudge-width="10" offset-x>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on"> mdi-dots-horizontal </v-icon>
                </template>
                <v-card>
                  <v-list dense dark color="primary">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Acciones para :</v-list-item-title>
                        <v-list-item-subtitle
                          >{{ item.nombreActivo }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-divider></v-divider>

                  <v-list>
                    <v-list-item-group dense v-model="selectedItem" color="#3768D4">
                      <v-list-item @click="generarPdf(item)">
                        <v-list-item-icon>
                          <v-icon>mdi-qrcode</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-subtitle>Generar Etiqueta</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="$store.state.usuario.rol !== 'lectura_mtto'"
                        @click="editItem(item)"
                      >
                        <v-list-item-icon>
                          <v-icon>mdi-file-edit</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-subtitle>Editar</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="mostrarDialogInfoEquipo(item)">
                        <v-list-item-icon>
                          <v-icon>mdi-information</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-subtitle>Información</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="$store.state.usuario.rol !== 'lectura_mtto'"
                        @click="mostrarDialogAvatar(item._id)"
                      >
                        <v-list-item-icon>
                          <v-icon>mdi-camera</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-subtitle>Actualizar Avatar</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-menu>
            </template>
          </v-data-table>
          <br />

          <div class="text-center">
            <v-pagination
              v-if="verNuevo == 0"
              v-model="page"
              :length="totalPages"
              :total-visible="7"
              @input="listar()"
            ></v-pagination>
          </div>
          <v-container grid-list-sm class="pa-4 white" v-if="verNuevo">
            <span class="headline">{{ formTitle }}</span>

            <v-layout row wrap>
              <v-flex xs11 sm11 lg11 x11>
                <v-stepper v-model="e6" vertical>
                  <v-stepper-step :complete="e6 > 1" step="1">
                    Tipo de Unidad
                    <small>Datos requeridos para continuar</small>
                  </v-stepper-step>
                  <v-stepper-content step="1">
                    <v-row>
                      <v-col col="4">
                        <v-select
                          v-model="tipoUnidad"
                          :items="tiposDeUnidad"
                          label="Tipo de Unidad"
                        ></v-select>
                      </v-col>
                      <v-col col="4">
                        <v-text-field
                          v-model="nombreActivo"
                          label="Activo"
                        ></v-text-field>
                      </v-col>
                      <v-col col="4">
                        <v-text-field v-model="marca" label="Marca"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col col="4">
                        <v-text-field v-model="modelo" label="Modelo"></v-text-field>
                      </v-col>
                      <v-col col="4">
                        <v-text-field v-model="anio" label="Año"></v-text-field>
                      </v-col>
                      <v-col col="4">
                        <v-text-field
                          v-model="capacidad"
                          label="Capacidad"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-btn color="primary" small @click="continuarStepper()">
                      Continuar</v-btn
                    >
                    <v-btn small @click="cancelarStepper()">Cancel</v-btn>
                  </v-stepper-content>
                  <v-stepper-step :complete="e6 > 2" step="2">
                    Estatus del Activo
                  </v-stepper-step>
                  <v-stepper-content step="2">
                    <v-row>
                      <v-col col="4">
                        <v-text-field
                          v-model="numeroSerie"
                          label="Numero de Serie"
                        ></v-text-field>
                      </v-col>
                      <v-col col="4">
                        <v-text-field
                          v-model="placa"
                          label="Numero de Placa"
                        ></v-text-field>
                      </v-col>
                      <v-col col="4">
                        <v-select
                          v-model="estatu"
                          :items="estatus"
                          label="Estatus"
                        ></v-select>
                      </v-col>
                      <v-col col="4">
                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="fechaAdquisicion"
                              label="Fecha de adquisición"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="fechaAdquisicion"
                            @input="menu2 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col col="4">
                        <v-text-field
                          v-if="estatu != 'Operativo'"
                          v-model="observaciones"
                          label="Observaciones"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-col col="4">
                      <v-switch
                        v-model="estatusActivoN"
                        label="El activo es nuevo?"
                        color="primary"
                        hide-details
                      ></v-switch>
                    </v-col>

                    <v-btn color="primary" @click="continuarStepper()"> Continue </v-btn>
                    <v-btn text @click="cancelarStepper()"> Cancel </v-btn>
                  </v-stepper-content>
                  <v-stepper-step :complete="e6 > 3" step="3">
                    Datos economicos
                  </v-stepper-step>
                  <v-stepper-content step="3">
                    <v-row>
                      <v-col col="4">
                        <v-text-field v-model="factura" label="Factura"></v-text-field>
                      </v-col>
                      <v-col col="4">
                        <v-text-field
                          v-model="numeroEconomico"
                          label="#Economico"
                        ></v-text-field>
                      </v-col>
                      <v-col col="4">
                        <v-text-field
                          v-model="claveMicrosip"
                          label="Clave Microsip"
                        ></v-text-field>
                      </v-col>
                      <v-col col="4">
                        <vuetify-money
                          cleareble="true"
                          v-model="costo"
                          label="Costo de la Unidad"
                          v-bind:options="options"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col col="4">
                        <v-file-input
                          v-model="documentos"
                          placeholder="Adjunta la información de factura, poliza etc"
                          label="Adjuntos"
                          multiple
                          prepend-icon="mdi-paperclip"
                        >
                          <template v-slot:selection="{ text }">
                            <v-chip small label color="primary">
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col col="8">
                        <v-data-table
                          dense
                          :headers="documentacionHeaders"
                          :items="documentacionAdjuntada"
                          hide-default-footer
                          item-key="name"
                          class="elevation-1"
                        >
                          <template v-slot:[`item.nombreDoc`]="{ item }">
                            <v-text-field v-model="item.nombreDocumento"></v-text-field>
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <v-icon
                              class="mr-2"
                              @click="descargarDocumentos(item.documentacion)"
                            >
                              mdi-link-variant
                            </v-icon>
                            <v-icon class="mr-2" @click="eliminarDocumento2(item)">
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-btn color="primary" @click="continuarStepper()">Continue</v-btn>
                    <v-btn @click="cancelarStepper()" text>Cancel</v-btn>
                  </v-stepper-content>
                  <v-stepper-step step="4"> Información de Resguardo </v-stepper-step>
                  <v-stepper-content step="4">
                    <v-row>
                      <v-col>
                        <v-autocomplete
                          :items="personales"
                          v-model="personal"
                          label="Resguardo"
                        ></v-autocomplete>
                      </v-col>
                      <v-col col="4" v-if="personal == '620bd9fb5ab18c95f201933a'">
                        <v-text-field v-model="notas" label="Notas"></v-text-field>
                      </v-col>
                      <v-col col="4">
                        <v-text-field
                          v-model="propietario"
                          label="Propietario"
                        ></v-text-field>
                      </v-col>

                      <v-col>
                        <v-autocomplete
                          :items="ubicaciones"
                          v-model="ubicacion"
                          label="Ubicacion"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-file-input
                          v-model="fotos"
                          placeholder="Adjunta las fotos"
                          label="Fotos"
                          multiple
                          prepend-icon="mdi-paperclip"
                        >
                          <template v-slot:selection="{ text }">
                            <v-chip small label color="primary">
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </v-col>
                    </v-row>
                    <v-btn color="primary" :loading="loading" @click="guardar()">
                      Guardar
                    </v-btn>
                    <v-btn @click="cancelarStepper()" text> Cancel </v-btn>
                  </v-stepper-content> </v-stepper
                ><br />
                <v-btn color="primary" @click="ocultarNuevo()"> Salir </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-col>
      </v-row>
    </div>
    <v-btn
      class="button-fab-1 mx-2"
      v-if="$store.state.usuario.rol !== 'lectura_mtto'"
      @click="mostrarNuevo()"
      dark
      fab
      color="primary"
      ><v-icon dark>mdi-crane</v-icon></v-btn
    >
  </v-container>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import S3 from "aws-s3";
import uploadImage from "../../utils/uploadImage";
import Catalogo from "../../api/Catalogo";
import evidencias from "../../utils/uploadImage";

export default {
  data() {
    return {
      documentacionHeaders: [
        { text: "Actions", value: "action" },
        { text: "Nombre del documento", value: "nombreDoc" },
      ],
      headers: [
        { text: "Activo", value: "nombreActivo", sortable: false },

        // { text: "Tipo de Unidad", value: "tipoUnidad", sortable: true },
        { text: "Numero Serie", value: "numeroSerie", sortable: false },
        { text: "Marca", value: "marca", sortable: false },
        { text: "Modelo", value: "modelo", sortable: false },

        // {
        //   text: "Empresa",
        //   value: "ubicacion.empresa.nombreComercial",
        //   sortable: true,
        // // },
        // { text: "Resguardo", value: "personal.nombreCompleto", sortable: true },
        // {
        //   text: "Departamento",
        //   value: "personal.departamento.departamento",
        //   sortable: true,
        // },
        { text: "Fotos y Docs", value: "fotosAdjuntos", sortable: false },
        // { text: "Documentos", value: "doc", sortable: true },
        { text: "Estatus", value: "estatu", sortable: false },
        { text: "Opciones", value: "opciones", sortable: false },
      ],
      mostrarTabla: false,
      hover: false,
      editarDocumentos: [],
      infoDocumentos: [],
      personales: [],
      search: "",
      loading: false,
      page: 1,
      totalPages: 0,
      activos: [],
      itemsPage: 15,
      tipoDeUnidad: "",
      documentacionAdjuntada: [],
      factura: "",
      logoImg:
        "data:image/png;base64,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",
      fotos: [],
      numeroEconomico: "",
      menuFotos: false,
      claveMicrosip: "",
      costo: "",
      estatusActivoN: false,
      nombreActivo: "",
      marca: "",
      rules: [(value) => !value || value.size < 3000000 || "Peso del archivo excedido"],
      modelo: "",
      fechaAdquisicion: "",
      tipoUnidad: "",
      personal: "",
      numeroSerie: "",
      foto: "",
      propietario: "",
      detalle: "",
      personQueEdita: "",
      ubicaciones: [],
      selectedItem: 1,
      anio: "",
      numeroDeSerie: "",
      extensionAdjunto: [],
      numbersRandomAdjunto: [],
      nombreAdjuntos: [],
      extensionAdjuntoDoc: [],
      numbersRandomAdjuntoDoc: [],
      nombreAdjuntosDoc: [],
      menu: false,
      modal: false,
      documentos: [],
      menu2: false,
      observaciones: "",
      placa: "",
      file3: "",
      fotosNull: [],
      documentosNull: [],
      ubicacion: "",
      ubicacionPorQuery: "",
      notas: "",
      estatu: "",
      fotoBase64: "",
      capacidad: "",
      dialogNuevaArrendadora: false,
      razonSocial: "",
      verNuevo: 0,
      editedIndex: false,
      e6: 1,
      nombreComercial: "",
      tiposDeUnidad: [
        "Autos y Pick Ups",
        "Motocicletas",
        "Tractocamion",
        "Plataforma",
        "Grúa Terrestre",
        "Montacargas",
        "Cargador Frontal",
      ],
      estatus: ["N/D", "Operativo", "Fuera de Servicio", "No Localizado", "Baja"],
      submited: "",
      alert: "",
      options: {
        locale: "en-US",
        prefix: "$",
        suffix: "",
        length: 11,

        company_logo: {
          w: 110,
          h: 35,
        },

        precision: 2,
      },
      qrCodeImage: null,
      dialog_info_equipo: false,
      info_equipo: [],
      filtro: "",
      arr: [],
      showFilterNumeroEconomico: "",
      showFilterTipoUnidad: "",
      showFilterNumeroSerie: "",
      showFilterPlaca: "",
      showFilterestatus: "",
      numero_economico_filter: "",
      tipo_unidad_filter: "",
      numero_serie_filter: "",
      numero_placa_filter: "",
      estatus_filter: "",
      dialogCarrouselFotos: false,
      fotos_carrousel: [],
      dialogAgregarAvatar: false,
      avatar_unidad: "",
      id: "",
    };
  },
  watch: {},
  computed: {
    config() {
      return {
        bucketName: "cicsagruas.net",
        dirName: "fotos" /* optional */,
        region: "us-west-1",
        accessKeyId: "AKIA5DNSJBDUIMGT267Y",
        secretAccessKey: "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",
        s3Url: this.baseUrl,
      };
    },
    configDoc() {
      return {
        bucketName: "cicsagruas.net",
        dirName: "documentos" /* optional */,
        region: "us-west-1",
        accessKeyId: "AKIA5DNSJBDUIMGT267Y",
        secretAccessKey: "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",
        s3Url: this.baseUrl,
      };
    },
    baseUrl() {
      return "https://s3.us-west-1.amazonaws.com/cicsagruas.net";
    },
    S3Client() {
      return new S3(this.config);
    },
    S3ClientDoc() {
      return new S3(this.configDoc);
    },
    newFileName() {
      return Math.random().toString().slice(2);
    },

    url() {
      return `${this.baseUrl}/${"fotos"}/`;
    },
    urlDoc() {
      return `${this.baseUrl}/${"documentos"}/`;
    },

    dateRangeText() {
      return this.dates.join(" al ");
    },
    formTitle() {
      return this.editedIndex ? "Editar" : "Nuevo Activo";
    },
  },
  created() {
    this.listar();
    this.selectPersonal();
    this.selectUbicacion();
  },
  methods: {
    generarPdf(item) {
      var doc = new jsPDF("l", "mm", [60, 110]);

      var startX = 5;
      var startY = 2;
      //Encabezado

      doc.addImage(this.logoImg, "JPEG", startX, (startY += 5), 50, 18);

      doc.setFontSize(9);
      doc.text(item.nombreActivo, 7, 35);
      doc.setFontSize(18);
      doc.setFont(undefined, "bold");
      doc.text(item.numeroEconomico, 7, 45);
      let url = item._id;
      this.generarQR(url);
      doc.addImage(this.qrCodeImage, "JPEG", 60, 10, 45, 45);

      doc.output("dataurlnewwindow");
    },

    listar() {
      let me = this;
      this.mostrarTabla = true;
      if (
        this.$store.state.usuario.rol == "root" ||
        this.$store.state.usuario.rol == "activos" ||
        this.$store.state.usuario.rol == "jefe_mtto" ||
        this.$store.state.usuario.rol == "lectura_mtto"
      ) {
        axios
          .post("/activos/list?page=" + this.page, this.arr)
          .then(function (response) {
            console.log(response.data.reg);
            me.activos = response.data.reg;
            me.totalPages = response.data.totalPaginas;
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(() => {
            this.mostrarTabla = false;
          });
      } else if (this.$store.state.usuario.rol == "capturista") {
        axios
          .get(
            "/activos/listActivosPorUsuario?created=" +
              this.$store.state.usuario.personal._id
          )
          .then(function (response) {
            me.activos = response.data;
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(() => {
            this.mostrarTabla = false;
          });
      }
    },
    obtenerUbicacion(_id) {
      axios
        .get("/ubicacion/query?_id=" + _id)
        .then(function (response) {
          return response.data.ubicacion;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    limpiar() {
      (this.arrendadora = ""), (this.razonSocial = "");
      (this.nombreActivo = ""),
        (this.tipoUnidad = ""),
        (this.marca = ""),
        (this.modelo = ""),
        (this.anio = ""),
        (this.capacidad = ""),
        (this.numeroSerie = ""),
        (this.placa = ""),
        (this.editarDocumentos = []),
        (this.documentacionAdjuntada = []),
        (this.extensionAdjunto = []);

      (this.nombreAdjuntos = []),
        (this.estatu = ""),
        (this.personQueEdita = ""),
        (this.detalle = ""),
        (this.personal = ""),
        (this.propietario = ""),
        (this.factura = ""),
        (this.numeroEconomico = ""),
        (this.claveMicrosip = ""),
        (this.observaciones = ""),
        (this.costo = ""),
        (this.notas = "");
      (this.documentos = []),
        (this.fotos = []),
        (this.fechaAdquisicion = ""),
        (this.foto = ""),
        (this.ubicacion = "");
      this.e6 = 1;
      this.editedIndex = false;
      this.alert = false;
    },

    orderattachment(fileObject) {
      const reader = new FileReader();

      reader.onload = (e) => {
        this.fotoBase64 = e.target.result;
      };
      reader.readAsBinaryString(fileObject);
      console.log("file object", fileObject);
    },

    adjuntoFoto(e) {
      const selectedImage = e.target.files[0];
      this.orderattachment(selectedImage);
    },

    async guardar() {
      let me = this;
      this.loading = true;

      // Aseguramos que la fecha de adquisición sea nula si no se ha definido
      if (this.fechaAdquisicion == "") {
        this.fechaAdquisicion = null;
      }

      // Inicializamos los arrays de adjuntos
      let adjuntosFotos = me.fotos || [];
      let adjuntosDocumentos = me.documentos || [];

      // Unimos las fotos y documentos en una sola promesa que se resolverá cuando ambos hayan sido subidos
      try {
        // Subir fotos y documentos a Cloudinary (promesas en paralelo)
        await Promise.all([
          ...adjuntosFotos.map(async (file, index) => {
            const url = await evidencias.evidenciasDocOt(file);
            me.nombreAdjuntos[index] = url; // Asignamos la URL de Cloudinary al array de fotos
          }),
          ...adjuntosDocumentos.map(async (file, index) => {
            const url = await evidencias.evidenciasDocOt(file);
            me.nombreAdjuntosDoc[index] = url; // Asignamos la URL de Cloudinary al array de documentos
          }),
        ]);

        // Una vez que ambas promesas (fotos y documentos) se resuelvan, procederemos a guardar el activo
        me._guardarActivo();
      } catch (error) {
        console.log("Error al subir archivos a Cloudinary", error);
      } finally {
        this.loading = false;
      }
    },

    // Método para actualizar o crear el activo
    _guardarActivo() {
      let me = this;
      console.log(me.editedIndex);

      // Validación de si se está editando un activo o creando uno nuevo
      if (me.editedIndex) {
        // Si no se cargaron fotos o documentos, asignar valores predeterminados (nulos)
        if (this.nombreAdjuntos.length == 0 && this.fotosNull) {
          this.nombreAdjuntos = this.fotosNull;
        } else if (this.nombreAdjuntosDoc.length == 0 && this.documentosNull) {
          this.nombreAdjuntosDoc = this.documentosNull;
        }

        // Añadir los documentos adjuntados a la propiedad documentacionAdjuntada
        for (let i = 0; i < me.documentos.length; i++) {
          console.log(this.nombreAdjuntosDoc[i]);
          this.documentacionAdjuntada.push({
            documentacion: this.nombreAdjuntosDoc[i],
            nombre: "doc" + i,
          });
        }

        // Hacer una solicitud PUT para actualizar el activo
        axios
          .put("/activos/update", {
            _id: me._id,
            nombreActivo: me.nombreActivo,
            tipoUnidad: me.tipoUnidad,
            marca: me.marca,
            modelo: me.modelo,
            anio: me.anio,
            capacidad: me.capacidad,
            numeroSerie: me.numeroSerie,
            placa: me.placa,
            estatu: me.estatu,
            detalle: me.detalle,
            observaciones: me.observaciones,
            personal: me.personal,
            propietario: me.propietario,
            factura: me.factura,
            numeroEconomico: me.numeroEconomico,
            claveMicrosip: me.claveMicrosip,
            costo: me.costo,
            ubicacion: me.ubicacion,
            documentacionInfo: me.documentacionAdjuntada,
            fechaDeAdquisicion: me.fechaAdquisicion,
            fotos: me.nombreAdjuntos,
            documentos: me.editarDocumentos,
            notas: me.notas,
            edited: me.personQueEdita,
            estatusActivo: me.estatusActivoN,
          })
          .then(function () {
            me.limpiar();
            me.listar();
            me.addSuccessNotification("Activo actualizado");
            me.ocultarNuevo();
          })
          .catch(function (error) {
            console.log(error);
            me.addErrorNotification("Error, verifica la informacion agregada");
          });
      } else {
        // Si no es un activo editado, hacer una solicitud POST para agregar el activo
        axios
          .post("/activos/add", {
            nombreActivo: this.nombreActivo,
            tipoUnidad: this.tipoUnidad,
            marca: this.marca,
            modelo: this.modelo,
            anio: this.anio,
            capacidad: this.capacidad,
            numeroSerie: this.numeroSerie,
            placa: this.placa,
            estatu: this.estatu,
            observaciones: this.observaciones,
            detalle: this.detalle,
            personal: this.personal,
            propietario: this.propietario,
            factura: this.factura,
            numeroEconomico: this.numeroEconomico,
            claveMicrosip: this.claveMicrosip,
            costo: this.costo,
            ubicacion: this.ubicacion,
            fechaDeAdquisicion: this.fechaAdquisicion,
            notas: this.notas,
            fotos: this.nombreAdjuntos,
            documentos: this.nombreAdjuntosDoc,
            estatusActivo: this.estatusActivoN,
            created: this.$store.state.usuario.personal._id,
          })
          .then(function () {
            me.limpiar();
            me.listar();
            me.addSuccessNotification("Activo agregado");
            me.ocultarNuevo();
          })
          .catch(function (error) {
            console.log(error);
            me.addErrorNotification("Error, verifica la informacion agregada");
          });
      }
    },

    selectPersonal() {
      let me = this;
      let personalArray = [];
      if (
        this.$store.state.usuario.rol == "root" ||
        this.$store.state.usuario.rol == "activos"
      ) {
        axios
          .get("/personal/list")
          .then((response) => {
            personalArray = response.data;
            personalArray.map(function (x) {
              me.personales.push({ text: x.nombreCompleto, value: x._id });
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      } else if (this.$store.state.usuario.rol == "capturista") {
        axios
          .get(
            "/personal/listPorEmpresa?empresa=" +
              this.$store.state.usuario.personal.empresa
          )
          .then((response) => {
            personalArray = response.data;
            personalArray.map(function (x) {
              me.personales.push({ text: x.nombreCompleto, value: x._id });
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    selectUbicacion() {
      let me = this;
      let ubicacionArray = [];
      if (
        this.$store.state.usuario.rol == "root" ||
        this.$store.state.usuario.rol == "activos"
      ) {
        axios
          .get("/ubicacion/list")
          .then((response) => {
            ubicacionArray = response.data;
            ubicacionArray.map(function (x) {
              me.ubicaciones.push({
                text: x.empresa.nombreComercial + " - " + x.ubicacion,
                value: x._id,
              });
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      } else if (this.$store.state.usuario.rol == "capturista") {
        axios
          .get(
            "/ubicacion/listPorEmpresa?empresa=" +
              this.$store.state.usuario.personal.empresa
          )
          .then((response) => {
            ubicacionArray = response.data;
            ubicacionArray.map(function (x) {
              me.ubicaciones.push({
                text: x.empresa.nombreComercial + " - " + x.ubicacion,
                value: x._id,
              });
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    editItem(item) {
      this._id = item._id;
      this.tipoUnidad = item.tipoUnidad;
      this.nombreActivo = item.nombreActivo;
      this.marca = item.marca;
      this.modelo = item.modelo;
      this.anio = item.anio;
      this.editarDocumentos = item.documentos;
      console.log(item.documentacionInfo);
      if (item.documentacionInfo) {
        this.documentacionAdjuntada = item.documentacionInfo;
      } else {
        if (item.documentos !== null) {
          if (item.documentos.length > 0) {
            for (let i = 0; i < item.documentos.length; i++) {
              this.documentacionAdjuntada.push({
                documentacion: item.documentos[i],
                nombre: "doc" + i,
              });
            }
          }
        }
      }

      this.capacidad = item.capacidad;
      this.numeroSerie = item.numeroSerie;
      this.placa = item.placa;
      this.estatu = item.estatu;
      this.personQueEdita = this.$store.state.usuario.personal._id;
      let fechaIso = "";
      if (item.fechaDeAdquisicion) {
        fechaIso = new Date(item.fechaDeAdquisicion).toISOString().substr(0, 10);
      }
      if (item.fechaDeAdquisicion) {
        if (fechaIso == "1970-01-01") {
          this.fechaAdquisicion = "";
        } else {
          this.fechaAdquisicion = new Date(item.fechaDeAdquisicion)
            .toISOString()
            .substr(0, 10);
        }
      }
      if (item.personal) {
        this.personal = item.personal._id;
      }
      this.estatusActivoN = item.estatusActivo;
      this.factura = item.factura;
      this.numeroEconomico = item.numeroEconomico;
      this.claveMicrosip = item.claveMicrosip;
      this.notas = item.notas;
      this.fotosNull = item.fotos;
      this.documentosNull = item.documentos;
      this.costo = item.costo;
      this.observaciones = item.observaciones;

      if (item.ubicacion) {
        this.ubicacion = item.ubicacion._id;
      }
      this.propietario = item.propietario;
      this.editedIndex = true;

      this.mostrarNuevo();
    },
    mostrarNuevo() {
      // this.listarAgencia(this.$store.state.usuario.agencia)

      this.verNuevo = 1;
    },
    ocultarNuevo() {
      this.verNuevo = 0;
      this.limpiar();
    },

    mostrarCarrousel(fotos) {
      console.log(fotos);
      this.dialogCarrouselFotos = true;
      this.fotos_carrousel = fotos;
      console.log(fotos);
    },

    addSuccessNotification(mensaje) {
      this.$toast.success(mensaje, {
        position: "top-right",
        timeout: 2000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
      });
    },
    addErrorNotification() {
      this.$toast.error("Error, verifique los campos ingresados", {
        position: "bottom-right",
        timeout: 2000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
      });
    },
    cerrarModalArrendadora() {
      this.dialogNuevaArrendadora = false;
      this.limpiar();
      this.editedIndex = false;
    },
    continuarStepper() {
      if (this.e6 == 1) {
        if (
          this.nombreActivo == "" ||
          this.tipoUnidad == "" ||
          this.marca == "" ||
          this.modelo == "" ||
          this.anio == ""
        ) {
          this.addErrorNotification();
        } else {
          this.e6 = 2;
        }
      } else if (this.e6 == 2) {
        if (this.numeroSerie == "" || this.placa == "" || this.estatu == "") {
          this.addErrorNotification();
        } else {
          this.e6 = 3;
        }
      } else if (this.e6 == 3) {
        if (
          this.conceptoFactura == "" ||
          this.numeroEconomico == "" ||
          this.claveMicrosip == "" ||
          this.costo == ""
        ) {
          this.addErrorNotification();
        } else {
          this.e6 = 4;
        }
      } else if (this.e6 == 4) {
        if (this.propietario == "") {
          this.addErrorNotification();
        } else {
          this.guardar();
        }
      }
    },
    cancelarStepper() {
      if (this.e6 == 1) {
        this.ocultarNuevo();
      } else if (this.e6 == 2) {
        this.e6 = this.e6 - 1;
      } else if (this.e6 == 3) {
        this.e6 = this.e6 - 1;
      } else if (this.e6 == 4) {
        this.e6 = this.e6 - 1;
      }
    },
    descargarFotos(adjuntos) {
      window.open(adjuntos, "_blank");
    },
    descargarDocumentos(documentos) {
      window.open(documentos, "_blank");
    },
    // eliminarDocumento(arr, item) {
    //   let i = arr.indexOf(item);
    //   if (i != -1) {
    //     arr.splice(i, 1);
    //   }
    //   this.documentacionAdjuntada.splice(i, 1);
    // },
    eliminarDocumento2(item) {
      let i = this.documentacionAdjuntada.indexOf(item);
      if (i != -1) {
        this.documentacionAdjuntada.splice(i, 1);
      }
    },

    pruebaAdjuntos() {
      console.log(this.documentacionAdjuntada);
    },
    costoToDollar(text) {
      let number = parseFloat(text);
      return number.toLocaleString("en-US");
    },
    generarQR(url) {
      const options = {
        width: 256,
        height: 256,
      };

      QRCode.toDataURL(url, options, (err, url) => {
        if (err) console.error(err);
        else this.qrCodeImage = url;
      });
    },
    mostrarDialogInfoEquipo(item) {
      this.dialog_info_equipo = true;
      this.info_equipo = item;
    },

    eliminarFiltro(index) {
      this.arr.splice(index, 1);
      this.listar();
    },

    corregir(item) {
      const datos = {
        _id: item._id,
        empresa: item.ubicacion.empresa._id,
      };
      console.log(datos);
      Catalogo.corregirEmpresaList(datos)
        .then(() => {
          this.addSuccessNotification("correcto");
        })
        .catch(() => {
          this.addErrorNotification();
        });
    },

    filtroLabelPush(tipo) {
      if (tipo == "numeroEconomico") {
        let existe = this.arr.findIndex((e) => e.field == "numeroEconomico");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "numeroEconomico",
          value: this.numero_economico_filter,
          label: "NE: : " + this.numero_economico_filter,
        });
      } else if (tipo == "tipoUnidad") {
        let existe = this.arr.findIndex((e) => e.field == "tipoUnidad");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "tipoUnidad",
          value: this.tipo_unidad_filter,
          label: "Tipo de unidad : " + this.tipo_unidad_filter,
        });
      } else if (tipo == "numeroSerie") {
        let existe = this.arr.findIndex((e) => e.field == "numeroSerie");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "numeroSerie",
          value: {
            $regex: this.numero_serie_filter, // La cadena que quieres buscar
            $options: "i", // 'i' indica que la búsqueda no distingue entre mayúsculas y minúsculas (opcional)
          },
          label: "Numero de serie : " + this.numero_serie_filter,
        });
      } else if (tipo == "placa") {
        let existe = this.arr.findIndex((e) => e.field == "placa");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "placa",
          value: this.numero_placa_filter,
          label: "Placa : " + this.numero_placa_filter,
        });
      } else if (tipo == "estatus") {
        let existe = this.arr.findIndex((e) => e.field == "estatus");
        if (existe >= 0) {
          this.arr.splice(existe, 1);
        }
        this.arr.push({
          field: "estatu",
          value: this.estatus_filter,
          label: "Estatus : " + this.estatus_filter,
        });
      }

      this.showFilterNumeroEconomico = false;
      this.showFilterTipoUnidad = false;
      this.showFilterestatus = false;
      this.showFilterPlaca = false;
      this.showFilterNumeroSerie = false;
      this.listar();
    },

    mostrarDialogAvatar(_id) {
      this.dialogAgregarAvatar = true;
      this.id = _id;
    },

    async subirAvatarUnidad() {
      if (!this.avatar_unidad) {
        this.addErrorNotification2("Ingresa la imagen");
        return;
      }
      this.mostrarTabla = true;
      await uploadImage.avatarUnidades(this.avatar_unidad).then((e) => {
        const datos = {
          avatar: e,
          _id: this.id,
        };
        Catalogo.agregarAvatar(datos)
          .then(() => {
            this.dialogAgregarAvatar = false;
            this.addSuccessNotification("Avatar agregada");
            this.listar();
            // this.evidencias_imagenes = e.data.evidencias;
            // console.log(e.data);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.mostrarTabla = false;
          });
      });
    },
  },
};
</script>
<style lang="scss">
@import "./Activos.scss";

.button-fab {
  bottom: 50px;
  height: 60px;
  position: fixed;
  right: 20px;
  width: 60px;
}

.texto {
  font-family: "Raleway", sans-serif;
}
</style>
